import Button from "components/components/Button/Button";
import styled, { css } from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const Container = styled.span`
  margin-left: 0.6em;
`;

const inlineActionSizing = css`
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  height: 2.4em;
`;

export const StyledButton = styled(Button)`
  ${resetButtonStyling};
  ${inlineActionSizing};
  text-transform: none;
  letter-spacing: normal;
  font-size: ${fonts.small};
  text-decoration: underline;
  background: transparent;
  text-underline-offset: 4px;
  box-shadow: none;

  &:hover {
    color: ${colours.elexonBlue};
    background: transparent;
    text-decoration: underline;
  }

  &:active {
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid ${colours.elexonBlack};
    outline-offset: 4px;
    border-radius: 2px;
  }
`;

export const CopiedStatus = styled.span`
  ${inlineActionSizing};
`;
